document.addEventListener("DOMContentLoaded", function () {
  // Fetches the current cart object from the API.
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Check if the cart is empty.
      if (cart.item_count === 0) return;

      // Store the discount codes in an array, before that, remove the spaces.
      const discountCodesTriggers = bfTriggers
        .split(",")
        .map((code) => code.trim());

      // Check if the cart has a discount code applied and render the discounted price.
      cart.items.forEach((item) => {
        // Check each discount in discounts array and see if it matches the discount code trigger.
        let codeFound = false;

        item.discounts.forEach((discount) => {
          if (discountCodesTriggers.includes(discount.title)) {
            codeFound = true;
          }
        });

        if (
          codeFound &&
          document.querySelector(
            `.main-product__block input[name="id"][value="${item.id}"]`
          )
        ) {
          const discountedPrice = item.line_price;

          // Set a linethrough on the original price + tone down the color and font-size.
          document.querySelector(
            ".prod__reviews-and-prices .f-price-item--regular"
          ).style.textDecoration = "line-through";
          document.querySelector(
            ".prod__reviews-and-prices .f-price-item--regular"
          ).style.color = "#999";
          document.querySelector(
            ".prod__reviews-and-prices .f-price-item--regular"
          ).style.fontSize = "18px";

          const priceElement = document.createElement("div");
          priceElement.classList.add("f-price");
          priceElement.innerHTML = `
          <div class="discounted-price" style="display: flex; flex-direction: column;">
            <span style="font-size: 16px; font-weight: 400; text-align: left;" class="f-price__label">Black Friday: </span>
            <span style="margin: 0;" class="f-price-item f-price-item--sale text-xl md:text-2xl prod__price text-color-regular-price">${formatMoney(
              discountedPrice,
              money_format
            )}</span>
          </div>
        `;
          document
            .querySelector(
              `.main-product__block.main-product__block-price .prod__reviews-and-prices`
            )
            .after(priceElement);
        }
      });
    });

  // Fix for atc-button on variant change.
  setTimeout(() => {
    document.querySelectorAll(".variant-picker__option").forEach((option) => {
      option.addEventListener("click", () => {
        const variantid = option.getAttribute("data-variantid");
        const atc = document.querySelector(".add-to-cart");
        const variantRule = variantsContinueSelling[variantid];
        setTimeout(() => {
          if (variantRule) {
            atc.classList.remove("disabled");
            atc.removeAttribute("disabled");
          }
        }, 200);
      });
    });
  }, 800);

  /**
   * Popup functionality for the product-options info-bobbler. Updated by Graphie
   */

  const infoTriggers = document.querySelectorAll(".toggle--info_popup");
  const closeButtons = document.querySelectorAll(".close-popup");

  infoTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      // Removes active from all popups
      infoTriggers.forEach((infoTrigger) => {
        const infoPopupRef = infoTrigger.dataset.popupref;
        const infoPopupElement = document.querySelector(`#${infoPopupRef}`);
        infoPopupElement.classList.remove("active");
      });

      // Updates the correct active element
      const infoPopupRef = trigger.dataset.popupref;
      const infoPopupElement = document.querySelector(`#${infoPopupRef}`);
      if (!infoPopupElement.classList.contains("active")) {
        infoPopupElement.classList.add("active");
      } else {
        infoPopupElement.classList.remove("active");
      }
    });
  });

  // Close the popup when the close button is clicked
  closeButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      const popup = button.closest(".variant-info-popup");
      popup.classList.remove("active");
    });
  });

  // Funktion til at opdatere popup-data
  const updatePopupData = () => {
    const checkedInput = document.querySelector(".prod__option--image .variant-picker__option input:checked");
    if (!checkedInput) return;

    const button = checkedInput.nextElementSibling;

    // Get data attributes from the button
    const martindaleValue = button.getAttribute("data-martindale");
    const pillingValue = button.getAttribute("data-pilling");
    const farveaegthedValue = button.getAttribute("data-farveaegthed");
    const stoftypeValue = button.getAttribute("data-stoftype");
    const betraekValue = button.getAttribute("data-betraek");
    const thumbnail = button.getAttribute("data-thumbnail");

    // Locate the variant-image element and get the selected variant name
    const variantImage = document.querySelector("variant-image");
    const variantName = variantImage ? variantImage.getAttribute("data-selected-value") : "";

    // Debug logs
    console.log("Updating popup data with button:", button);
    console.log("Martindale value:", martindaleValue);
    console.log("Pilling value:", pillingValue);
    console.log("Farveægthed value:", farveaegthedValue);
    console.log("Thumbnail:", thumbnail);
    console.log("Variant name:", variantName);

    // Update the spans in the popup with the corresponding data
    document.querySelectorAll(".martindale-text").forEach(span => {
      span.textContent = martindaleValue ? martindaleValue.replace(/&quot;/g, "").replace(/\\/g, "") : "";
    });

    document.querySelectorAll(".pilling-text").forEach(span => {
      span.textContent = pillingValue ? pillingValue.replace(/&quot;/g, "").replace(/\\/g, "") : "";
    });

    document.querySelectorAll(".farveaegthed-text").forEach(span => {
      span.textContent = farveaegthedValue ? farveaegthedValue.replace(/&quot;/g, "").replace(/\\/g, "") : "";
    });
    
    document.querySelectorAll(".fabric-text").forEach(span => {
      span.textContent = stoftypeValue ? stoftypeValue.replace(/&quot;/g, "").replace(/\\/g, "") : "";
    });

    document.querySelectorAll(".cover-text").forEach(span => {
      span.textContent = betraekValue ? betraekValue.replace(/&quot;/g, "").replace(/\\/g, "") : "";
    });

    // Update the swatch image in the popup
    const popupImage = document.querySelector(".popup-thumbnail");
    if (popupImage) {
      popupImage.src = thumbnail ? thumbnail.replace(/&quot;/g, "").replace(/\\/g, "") : "";
    }

    // Update the variant name in the popup
    const popupVariantName = document.querySelector(".popup-variant-name");
    if (popupVariantName) {
      popupVariantName.textContent = variantName ? variantName.replace(/&quot;/g, "").replace(/\\/g, "") : "";
    }
  };

  const setInitialVariantData = () => {
    const checkedInput = document.querySelector(".prod__option--image .variant-picker__option input:checked");
    if (checkedInput) {
      const variantImage = document.querySelector("variant-image");
      if (variantImage) {
        variantImage.setAttribute("data-selected-value", checkedInput.value);
      }
    }
    updatePopupData();
  };

  // Initial update based on the selected variant
  setInitialVariantData();

  // Add event listener to all variant inputs
  const variantInputs = document.querySelectorAll(".prod__option--image .variant-picker__option input");
  variantInputs.forEach(input => {
    input.addEventListener("change", () => {
      const variantImage = document.querySelector("variant-image");
      if (variantImage) {
        variantImage.setAttribute("data-selected-value", input.value);
      }
      updatePopupData();
    });
  });
  const tooltip = document.createElement('div');
  tooltip.classList.add('tooltip');
  document.body.appendChild(tooltip);

  const items = document.querySelectorAll('.prod__option--image .variant-picker__option');

  items.forEach(item => {
    item.addEventListener('mouseover', function (e) {
      const dataValue = item.getAttribute('data-value');
      if (dataValue) {
        tooltip.textContent = dataValue;
        const rect = item.getBoundingClientRect();
        tooltip.style.left = `${rect.left + window.pageXOffset + rect.width / 2}px`;
        tooltip.style.top = `${rect.top + window.pageYOffset - tooltip.offsetHeight - 10}px`;
        tooltip.style.transform = 'translateX(-50%) translateY(-50%)'; // Center tooltip and move it up completely
        tooltip.style.display = 'block';
      }
    });

    item.addEventListener('mouseout', function () {
      tooltip.style.display = 'none';
    });
  });
});


/* MK: universel iOS-scroll-laas. Temaets drawers/modaler (cart, quick view, variant-,
   samples-, spec-drawer m.fl.) saetter alle klassen "prevent-scroll", men overflow:hidden
   stopper ikke touch-scroll/scroll-chaining paa iOS, saa siden bagved kan stadig scrolle.
   Denne watcher laaser body med position:fixed naar klassen er sat (kun mobil) og
   gendanner scroll-positionen praecist naar den fjernes. */
(function () {
  var lockedY = null;
  var mq = window.matchMedia('(max-width: 767px)');
  function isLocked() {
    return document.documentElement.classList.contains('prevent-scroll')
      || (document.body && document.body.classList.contains('prevent-scroll'));
  }
  function apply() {
    var locked = isLocked();
    if (locked && lockedY === null && mq.matches) {
      lockedY = window.scrollY;
      var bs = document.body.style;
      bs.position = 'fixed';
      bs.top = -lockedY + 'px';
      bs.left = '0';
      bs.right = '0';
      bs.width = '100%';
    } else if (!locked && lockedY !== null) {
      var bs = document.body.style;
      bs.position = '';
      bs.top = '';
      bs.left = '';
      bs.right = '';
      bs.width = '';
      window.scrollTo({ top: lockedY, behavior: 'instant' });
      lockedY = null;
    }
  }
  function init() {
    var mo = new MutationObserver(apply);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    apply();
  }
  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
